// extracted by mini-css-extract-plugin
export var component = "IframeGrid-module--component--1f43a";
export var container = "IframeGrid-module--container--e4935";
export var fadePop = "IframeGrid-module--fade-pop--caa77";
export var growHeightIn = "IframeGrid-module--grow-height-in--99e9e";